
import Vue from 'vue';
import { Runnit, RunnitMember, TeamMember } from '@run-diffusion/shared';
import { mapGetters, mapState } from 'vuex';
import { get$bindFirestoreOptions } from '@/mixins';
import { db, Query } from '@/firebase';
import RunnitBoardMemberJoinedStatus from './RunnitBoardMemberJoinedStatus.vue';

export default Vue.extend({
	name: 'RunnitBoardMemberRow',
	props: {
		runnitMember: { type: Object, required: true },
		runnit: { type: Object, required: true },
		// Who owns the board once saved, when the dialog has a new owner picked. Defaults to the board's.
		ownerUserId: { type: String, default: null },
	},
	data () {
		return {
			localTeamMembers: [] as TeamMember[],
			loadingTeamMember: false,
		};
	},
	computed: {
		...mapState([
			'user',
		]),
		...mapGetters([
			'displayLabels',
		]),
		localTeamMember (): TeamMember | null {
			return this.localTeamMembers?.[0] || null;
		},
		teamMemberEmail (): string {
			return this.localTeamMember?.email || '';
		},
	},
	watch: {
		runnitMember: {
			immediate: true,
			handler (newVal: RunnitMember, oldVal: RunnitMember) {
				if (newVal !== oldVal) {
					this.bindTeamMember(this.runnit?.teamId, newVal);
				}
			},
		},
		runnit: {
			immediate: true,
			handler (newVal: Runnit, oldVal: Runnit) {
				const newTeamId: string = newVal?.teamId;
				const oldTeamId: string = oldVal?.teamId;
				if (newTeamId !== oldTeamId) {
					this.bindTeamMember(newTeamId, this.runnitMember);
				}
			},
		},
	},
	methods: {
		async bindTeamMember (teamId: string, runnitMember: RunnitMember) {
			if (!teamId || !runnitMember?.userId) {
				this.localTeamMembers = [];
				return;
			}

			this.loadingTeamMember = true;
			try {
				const teamMemberRef: Query = db.collection(`teams/${teamId}/teamMembers`)
					.where('userId', '==', runnitMember.userId)
					.limit(1);

				await this.$bind(
					'localTeamMembers',
					teamMemberRef,
					get$bindFirestoreOptions(),
				);
			} catch (error) {
				console.error('Error binding team member:', error);
			} finally {
				this.loadingTeamMember = false;
			}
		},
		onRemoveMember () {
			this.$emit('remove');
		},
	},
	components: {
		RunnitBoardMemberJoinedStatus,
	},
});
